angular.module('lsnBase.deprecated.models')
  .factory('ApplicationAllowedChangesAttributeModel', ['LsnApplicationAllowedChangesAttributeModelV1',
    function(LsnApplicationAllowedChangesAttributeModelV1) {
      return LsnApplicationAllowedChangesAttributeModelV1;
    }
  ]);